import { render, staticRenderFns } from "./BannerStats.vue?vue&type=template&id=7d9952ec&scoped=true"
import script from "./BannerStats.vue?vue&type=script&lang=js"
export * from "./BannerStats.vue?vue&type=script&lang=js"
import style0 from "./BannerStats.vue?vue&type=style&index=0&id=7d9952ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9952ec",
  null
  
)

export default component.exports